export const YI_MEDIA_ROOT_PATH = '/yi/media'
export const YI_MEDIA_CREATE_PATH = `${YI_MEDIA_ROOT_PATH}/create`
export const YI_CONTENT_ROOT_PATH = '/yi/content'
export const YI_CONTENT_CREATE_PATH = `${YI_CONTENT_ROOT_PATH}/create`
